/* RESPONSIBLE TEAM: team-automation-foundations */
import type FreeInput from 'embercom/models/operator/visual-builder/step/free-input';
import StepConfig, { type StepConfigParams } from '../step';

export default class FreeInputConfiguration extends StepConfig {
  declare step: FreeInput;

  constructor(params: Omit<StepConfigParams, 'component'>) {
    super({
      component: 'workflows/graph-editor/node-items/steps/free-input',
      ...params,
    });
  }
}
